// extracted by mini-css-extract-plugin
module.exports = {"container":"HeadingWidget_container__2Lnbl","hr":"HeadingWidget_hr__2y5KC"};